import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  class: "select__asterisk",
  "aria-hidden": "true"
}, "*", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "sr-only" }, "(required)", -1)
const _hoisted_3 = ["title", "aria-disabled", "aria-readonly", "aria-required", "tabindex"]
const _hoisted_4 = {
  key: 0,
  class: "scrollable-select__dropdown__search"
}
const _hoisted_5 = {
  key: 1,
  class: "scrollable-select__dropdown__search"
}
const _hoisted_6 = ["aria-setsize", "aria-posinset", "aria-selected", "title", "onClick", "onKeydown"]
const _hoisted_7 = {
  key: 1,
  class: "select__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["scrollable-select select", _ctx.required ? 'select--required' : null])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.hideLabel ? 'sr-only' : null)
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_1,
            _hoisted_2
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["scrollable-select__selector select__selector", [
        _ctx.status ? 'select--' + _ctx.status : '',
        _ctx.disabled ? 'select__selector--disabled' : '',
        _ctx.readonly ? 'select__selector--readonly' : '',
        _ctx.status && _ctx.disabled ? 'select--' + _ctx.status + '--disabled' : '',
        _ctx.isListDisplayed && !_ctx.disabled ? 'scrollable-select__selector--visible' : '',
      ]]),
      title: _ctx.placeholderValue,
      "aria-haspopup": "listbox",
      "aria-disabled": _ctx.disabled,
      "aria-readonly": _ctx.readonly,
      "aria-required": _ctx.required,
      role: "button",
      tabindex: _ctx.disabled ? null : '0',
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDropdownClick && _ctx.handleDropdownClick(...args))),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDropdownClick && _ctx.handleDropdownClick(...args)), ["prevent"]), ["space"]))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["scrollable-select__placeholder", !_ctx.selectedItemKey && 'placeholder-clr'])
      }, _toDisplayString(_ctx.placeholderValue), 3)
    ], 42, _hoisted_3),
    (_ctx.isListDisplayed && !_ctx.disabled && !_ctx.readonly)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["scrollable-select__dropdown", [_ctx.isListDisplayed ? 'scrollable-select__dropdown--visible' : '']])
        }, [
          (!_ctx.noSearch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  class: "scrollable-select__dropdown__search__input",
                  type: "search",
                  placeholder: "Search...",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilterInput) = $event)),
                  onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterOptions && _ctx.filterOptions(...args))),
                  "aria-label": "Search through the list"
                }, null, 544), [
                  [_vModelText, _ctx.searchFilterInput]
                ])
              ]))
            : (_ctx.allowInput)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    class: "scrollable-select__dropdown__search__input",
                    type: "text",
                    placeholder: "Type to input...",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputValue) = $event)),
                    onKeydown: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleEnter && _ctx.handleEnter(...args)), ["enter"])),
                    "aria-label": "Type to input"
                  }, null, 544), [
                    [_vModelText, _ctx.inputValue]
                  ])
                ]))
              : _createCommentVNode("", true),
          _createElementVNode("ul", {
            class: _normalizeClass(["scrollable-select__dropdown__list", Object.keys(_ctx.filteredOptions).length > 5 ? 'pr-2' : '']),
            role: "listbox"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.filteredOptions), (key, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["scrollable-select__dropdown__list-item overflow-x--hidden", [_ctx.isSelectedItem(key) ? 'scrollable-select__dropdown__list-item--selected' : '']]),
                key: index,
                role: "option",
                tabindex: "0",
                "aria-setsize": Object.keys(_ctx.options).length,
                "aria-posinset": index + 1,
                "aria-selected": _ctx.isSelectedItem(key),
                title: _ctx.filteredOptions[key],
                onClick: ($event: any) => (_ctx.selectListItem(key)),
                onKeydown: _withKeys(($event: any) => (_ctx.selectListItem(key)), ["enter"])
              }, _toDisplayString(_ctx.filteredOptions[key]), 43, _hoisted_6))
            }), 128))
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    ((!_ctx.isListDisplayed && _ctx.message && _ctx.status) || _ctx.disabled)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_click_away, _ctx.closeDropdown]
  ])
}